const style = {
  color: 'red',
};

function ErrorText({ text }: { text: string }) {
  return (
    <span style={style}>
      {text}
    </span>
  );
}

export default ErrorText;
